import { buildTableData } from './buildTableData';
import { useOrderByTableData } from '../../useOrderByTableData';
import { usePagination } from '@lifeomic/phc-web-toolkit/src/services/util/usePagination';
import * as React from 'react';
import GenomicsService from '@lifeomic/phc-web-toolkit/src/services/GenomicsService';
import { VariantsContentProps } from '../types';
import VariantContent from '../VariantContent';

const genomicsService = new GenomicsService();

export const CopyNumberVariantsContent: React.FC<VariantsContentProps> = ({
  onRowClick,
  fetchPrependedColumns,
}) => {
  const {
    hasMoreToLoad,
    isLoading,
    loadMore,
    makeFetchRequest,
    results,
    lastResponse,
    error,
    resetResults,
  } = usePagination(genomicsService.getCopyNumbers);

  const { handleSortClicked, sortedData } = useOrderByTableData(results);

  return (
    <VariantContent
      onRowClick={onRowClick}
      fetchPrependedColumns={fetchPrependedColumns}
      setType={'copyNumberVariant'}
      isLoading={isLoading}
      hasMoreToLoad={hasMoreToLoad}
      loadMore={loadMore}
      sortedData={sortedData}
      handleSortClicked={handleSortClicked}
      resetResults={resetResults}
      makeFetchRequest={makeFetchRequest}
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      lastResponse={lastResponse}
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      error={error}
      buildTableData={buildTableData}
    />
  );
};
